/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Add1Inputs */

const vi_cmspost_add1 = /** @type {(inputs: Cmspost_Add1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viết bài`)
};

/**

* @param {Cmspost_Add1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_add1 = /** @type {((inputs?: Cmspost_Add1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Add1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_add1(inputs)
});
export { cmspost_add1 as "cmsPost_add" }